$(document).ready(function() {
    $('.variant-btn').click(function() {
        let comp_price = $(this).data('compare'),
            orgn_price = $(this).data('price'),
            atc_url = $(this).data('url');
    
        if($(this).hasClass('color-gold')){
            $('.featured-product-image [data-color=gold]').addClass('selected').siblings().removeClass('selected');
            $('.sticky-atc-inner .current').text('Rose Gold');
        }else{
            $('.featured-product-image [data-color=black]').addClass('selected').siblings().removeClass('selected');
            $('.sticky-atc-inner .current').text('Black');
        }
    
        $(document).find('.btn').each(function() {
            $(this).attr('href', atc_url);
            $(this).find('.compare').text(comp_price);
            $(this).find('.original-price').text(orgn_price);
        })
    })

    var $atcSection = $('.featured-product');
    var $stickyAtc = $('.sticky-atc');
    var atcSectionOffset = $atcSection.offset().top;

    $(window).on('scroll', function() {
        if ($(window).scrollTop() >= atcSectionOffset) {
            $stickyAtc.fadeIn();
        } else {
            $stickyAtc.fadeOut();
        }
    });

    $('.smart-section-slider').slick({
      dots: false,
      arrows:false,
      autoplay:true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true
          }
        }
      ]
    });

    $(".custom-temstimonial-footer-slider").slick({
        dots:!0,
        arrows:false,
        infinite:!0,
        autoplay:true,
        slidesToShow:2,
        slidesToScroll:1,
        responsive:[
          {
            breakpoint:600,
            settings:{
               slidesToShow:1
            }
          }
        ]
    });

    if(window.innerWidth < 768){
        $(".top-features-content div").show();
        $(".top-features-content").slick({
            dots:false,
            arrows:false,
            infinite:true,
            speed:700,
            autoplay:true,
            slidesToShow:1,
            slidesToScroll:1,
        });
    }else{
        var slider = $('.top-features-icons-slides').slick({
          dots: false,
          arrows:true,
          autoplay:true,
          infinite: true,
          slidesToShow: 4,
          slidesToScroll: 1
        });
      
        slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
          $('.top-features-icons-slides [data-index="'+currentSlide+'"]').click();
        });
      
        const $carousel = $(".carousel");
        const $slides = $(".slide");
        const $controlLinks = $(".top-features-icons-slide");
      
        let i = 0,
            j = 1,
            intervalId;
      
        const intervalFn = () => {
          intervalId = setInterval(() => {
            $carousel.css('transform', `rotate(${-++i * 51.42}deg)`);
      
            $(".slide.active").removeClass("active");
            const $activeSlide = $(`.slide:nth-child(${++j})`);
            $activeSlide.addClass("active");
      
            $("a.active").removeClass("active");
            const $activeLink = $(`.controls a:nth-child(${j})`);
            $activeLink.addClass("active");
      
            if (j === 4) {
              j = 0;
            }
          }, 4000);
        };
      
        $controlLinks.on("click", function() {
          clearInterval(intervalId);
      
          const index = $(this).data("index");
          $carousel.css('transform', `rotate(${- (i - j + index) * 51.42}deg)`);
      
          $(".slide.active").removeClass("active");
          const $activeSlide = $(`.slide:nth-child(${index})`);
          $activeSlide.addClass("active");
  
          $(`.top-features-content div[data-index=${index}]`).show().siblings().hide();
          $(this).addClass("active").siblings().removeClass("active");
        });
    }
  
    // $(".section-seenon-logos-inner").slick({
    //     dots:false,
    //     arrows:true,
    //     infinite:!0,
    //     slidesToShow:3,
    //     autoplay:false,
    //     slidesToScroll:1,
    //     responsive:[
    //       {
    //         breakpoint:600,
    //         settings:{
    //            slidesToShow:2
    //         }
    //       }
    //     ]
    // });

});

document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger);
    if(window.innerWidth > 768){
        gsap.to(".ani-1", {
            scrollTrigger:{
                trigger: ".why-choose-main",
                start: "100% 50%",
                end: "0% 100%",
                scrub: true,
                // markers: true,
            },
            y: "-15%",
        });
        gsap.to(".ani-2", {
            scrollTrigger:{
                trigger: ".team-section-main",
                start: "100% 50%",
                end: "250% 100%",
                scrub: true,
                // markers: true,
            },
            y: "-15%",
        });
        gsap.to(".section-seenon-video a", {
            scrollTrigger:{
                trigger: ".section-seenon-main",
                start: "30% 100%",
                end: "150% 100%",
                scrub: true,
                // markers: true,
            },
            x: "2%",
            y: "-27%",
            rotate: "-16deg",
        });
    }else{
        gsap.to(".ani-1", {
            scrollTrigger:{
                trigger: ".why-choose-main",
                start: "100% 50%",
                end: "270% 100%",
                scrub: true,
                // markers: true,
            },
            y: "-15%",
        });
        gsap.to(".ani-2", {
            scrollTrigger:{
                trigger: ".team-section-main",
                start: "100% 50%",
                end: "250% 100%",
                scrub: true,
                // markers: true,
            },
            y: "-15%",
        });
    }
})